import { Dollars, Microdollars } from "model/modelTypes";

export enum CapType {
  NONE = "NONE",
  DAILY = "DAILY",
  HOURLY = "HOURLY",
}

export enum DayOfWeek {
  MONDAY = "MONDAY",
  TUESDAY = "TUESDAY",
  WEDNESDAY = "WEDNESDAY",
  THURSDAY = "THURSDAY",
  FRIDAY = "FRIDAY",
  SATURDAY = "SATURDAY",
  SUNDAY = "SUNDAY",
}

export type IDowConfig<T = Microdollars> = Partial<Record<DayOfWeek, T>>;

export type ICap = {
  type: CapType;
  value?: Microdollars;
  dowConfig?: IDowConfig;
};
export type IDollarCap = Omit<ICap, "value" | "dowConfig"> & {
  value: Dollars;
  dowConfig?: IDowConfig<Dollars>;
};

export const BACKEND_LINEITEM_NULL_BUDGET = -1;
//-1 represents 'no budget' on backend

export type ImpressionLimit = {
  type: CapType;
  value: Dollars;
};

export type PublisherSpendLimitMicro = {
  type: CapType;
  value: Microdollars;
};

export type PublisherSpendLimitDollars = {
  type: CapType;
  value: Dollars;
};

export enum Pacing {
  "NO_CHANGE" = "NO_CHANGE",
  "EVENLY" = "EVENLY",
  "ASAP" = "ASAP",
  "TRAFFIC" = "TRAFFIC",
  "TRAFFIC_US" = "TRAFFIC_US",
  "TRAFFIC_EMEA" = "TRAFFIC_EMEA",
  "TRAFFIC_APAC" = "TRAFFIC_APAC",
}

// how fast the line item burns through its bid rate, separate from the budget
// pacing above
export enum BidRatePacing {
  "EVENLY" = "EVENLY",
  "ASAP" = "ASAP",
}

// ASAP until the even bid rate pacing is fixed on the back end
export const DEFAULT_BID_RATE_PACING = BidRatePacing.ASAP;

export const BID_RATE_PACING_TOOLTIP =
  "Setting bidding pacing to ASAP campaign will have extremely high bid rate.";

export const BID_RATE_PACING_OPTIONS = [
  { value: BidRatePacing.EVENLY, label: "Even" },
  { value: BidRatePacing.ASAP, label: "ASAP" },
];

export const isTrafficPacing = (pacing?: Pacing) =>
  pacing === Pacing.TRAFFIC ||
  pacing === Pacing.TRAFFIC_US ||
  pacing === Pacing.TRAFFIC_EMEA ||
  pacing === Pacing.TRAFFIC_APAC;

export const capSupportsDowConfig = (capType?: CapType) =>
  capType === CapType.DAILY;
